import { render, staticRenderFns } from "./behavior.vue?vue&type=template&id=bbfbd68a&"
import script from "./behavior.vue?vue&type=script&lang=js&"
export * from "./behavior.vue?vue&type=script&lang=js&"
import style0 from "./behavior.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports